import { invoke, isEmpty } from 'lodash';
import request from './request';

const GA4_ID = 'G-M727JN039N';

// analytics class to handle
// 3rd party analytics service
Pollfish.analytics = (function analytics() {
  // send all events to analytics
  const bulkEvents = (category, event, label) => {
    if (typeof gtag !== 'undefined') {
      gtag('event', event, { category, label });
    }
  };

  return {
    // include and init 3rd party analytics library
    // append google analytics script
    /* eslint-disable */
    init() {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
      script.async = true;
      document.body.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA4_ID);

      if (typeof gtag === 'undefined') {
        return;
      }

      var userDetails = invoke(window, 'Pollfish.getUserDetails') || {};

      if (userDetails) {
        if (userDetails.sdk_version) {
          gtag('set', {'sdk_version': userDetails.sdk_version});
        }
        if (userDetails.survey_id) {
          gtag('set', {'survey_id': userDetails.survey_id});
        }
        if (userDetails.device_id) {
          gtag('set', {'device_id': userDetails.device_id});
        }
        if (userDetails.api_key) {
          gtag('set', {'api_key': userDetails.api_key});
        }
        if (userDetails.placement_key) {
          gtag('set', {'placement_key': userDetails.placement_key});
        }
      }

      const deviceType = invoke(Pollfish, 'helper.getDeviceType');
      if (deviceType) {
        gtag('set', {'device_type': deviceType});
      }
      const integrationType = invoke(Pollfish, 'helper.getIntegrationType');
      if (integrationType) {
        gtag('set', {'integration_type': integrationType});
      }
    },
    /* eslint-enable */

    // send event to analytics library
    // add mil(milliseconds) if you need to set timeout
    sendEvent(category, event, label, mil) {
      if (mil !== undefined) {
        setTimeout(() => {
          bulkEvents(category, event, label);
        }, mil);
      } else {
        bulkEvents(category, event, label);
      }
    },
    sendMetric(data) {
      if (!data || isEmpty(data) || !data.metric || !data.tags) {
        // eslint-disable-next-line
        console.error(
          `sendMetric expects an object like { metric: string, tags: object }, received ${JSON.stringify(
            data,
          )} instead`,
        );
        return;
      }
      // tags should always be strings
      const transformedData = {
        ...data,
        tags: {},
      };
      Object.keys(data.tags).forEach((tag) => {
        const value = data.tags[tag];
        try {
          transformedData.tags[tag] = value.toString();
        } catch (e) {
          // if value is not transformable to string, then dont send it
          // eslint-disable-next-line
          console.warn(`Tried transforming ${value} to string but failed`);
        }
      });
      request({
        url: '/v2/metrics/counter/increment',
        method: 'POST',
        contentType: 'application/json',
        transformData: false,
        data: transformedData,
      });
    },
  };
})();

export default Pollfish.analytics;
